export default function PrivacyPage() {
    return (
        <div className="container">
            <br />
            <br />
            <h2 className="text-center">
                <b>นโยบายความเป็นส่วนตัว</b>
            </h2>
            <p></p>
            <h5>
                <b>นโยบายความเป็นส่วนตัว</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; เว็บไซต์และแอพพลิเคชั่นนี้ เป็นของและดำเนินงานโดย สถาบันวิทยาศาสตร์ข้าวแห่งชาติ
                ที่ยึดมั่นต่อการปกป้องและเคารพความเป็นส่วนตัวของคุณ
            </p>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; นโยบายสิทธิส่วนบุคคลฉบับนี้ กำหนดพื้นฐานซึ่งเราจะใช้ในการดำเนินการข้อมูลส่วนตัวที่เราเก็บรวมรวบจากคุณ
                หรือที่คุณได้ให้เราไว้ ซึ่งจะถูกดำเนินการโดย สถาบันวิทยาศาสตร์ข้าวแห่งชาติ
                กรุณาอ่านข้อความต่อไปนี้อย่างละเอียดเพื่อทำความเข้าใจมุมมองและแนวปฏิบัติของเราเกี่ยวกับข้อมูลส่วนตัวของคุณ
            </p>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp;
                การที่คุณใช้เว็บไซต์และแอพพลิเคชั่นนี้แสดงว่าคุณยินยอมให้เรารวบรวมและดำเนินการข้อมูลส่วนตัวของคุณดังที่กำหนดไว้ในนโยบายสิทธิส่วนบุคคล
                ฉบับนี้ สถาบันวิทยาศาสตร์ข้าวแห่งชาติ เป็นผู้ควบคุมดูแลการดำเนินการใดๆ
                เกี่ยวกับข้อมูลส่วนตัวที่มีการรวบรวมผ่านเว็บไซต์และแอพพลิเคชั่นนี้
            </p>
            <h5>
                <b>ข้อมูลที่เราอาจรวบรวมจากคุณ</b>
            </h5>
            <h6>
                <b>เราอาจจะรวบรวมและดำเนินการกับข้อมูลของคุณ ดังต่อไปนี้</b>
            </h6>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; – ข้อมูลที่คุณให้ไว้หรือกรอกข้อมูลบนเว็บไซต์และแอพพลิเคชั่นผ่านบริการต่างๆ ของเรา ได้แก่
                ข้อมูลที่คุณกรอกในขณะที่ลงทะเบียนเพื่อเข้าชมเว็บไซต์และแอพพลิเคชั่น, การบอกรับข่าวสารเกี่ยวกับบริการของเรา, ลงทะเบียนเพื่อการซื้อขาย,
                โพสข้อความ, ส่งข้อมูลหรือเพื่อขอรับบริการต่างๆ
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp; – รายละเอียดการเข้าชมเว็บไซต์และแอพพลิเคชั่นนี้ของคุณ ไม่จำกัดเพียง ข้อมูลปริมาณการใช้ ข้อมูลสถานที่ตั้ง
                เว็บบล็อก และข้อมูลสื่อสารอื่นๆ ไม่ว่าเป็นข้อมูลที่จำเป็นต่อการเรียกเก็บเงินของคุณเองหรืออื่นๆ และแหล่งข้อมูลที่คุณเข้าถึง
            </p>
            <h5>
                <b>หมายเลข IP ADDRESSES</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; เราอาจรวบรวมข้อมูลเกี่ยวกับคอมพิวเตอร์ของคุณ รวมทั้งที่อยู่ IP ระบบปฏิบัติการและประเภทเบราว์เซอร์
                เพื่อการดูแลระบบและเพื่อรายงานข้อมูลในภาพรวมไปยังผู้ลงโฆษณากับเรา
                ข้อมูลนี้เป็นข้อมูลเชิงสถิติเกี่ยวกับการเรียกดูและรูปแบบการเรียกดูเว็บไซต์และแอพพลิเคชั่นของผู้ใช้ และไม่ได้ระบุแยกเป็นรายบุคคล
            </p>
            <h5>
                <b>คุกกี้</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp;
                หากคุณแสดงความคิดเห็นในเว็บไซต์และแอพพลิเคชั่นของเราคุณสามารถเลือกที่จะบันทึกชื่อที่อยู่อีเมลและเว็บไซต์และแอพพลิเคชั่นในคุกกี้
                เหล่านี้เพื่อความสะดวกของคุณเพื่อให้คุณไม่ต้องกรอกรายละเอียดของคุณอีกครั้งเมื่อคุณแสดงความคิดเห็นอื่น คุกกี้เหล่านี้จะมีอายุหนึ่งปี
                หากคุณมีบัญชีและคุณเข้าสู่เว็บไซต์และแอพพลิเคชั่นนี้เราจะตั้งค่าคุกกี้ชั่วคราวเพื่อตรวจสอบว่าเบราว์เซอร์ของคุณยอมรับคุกกี้หรือไม่
                คุกกี้นี้ไม่มีข้อมูลส่วนบุคคลและจะถูกยกเลิกเมื่อคุณปิดเบราว์เซอร์
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;
                เมื่อคุณลงชื่อเข้าใช้เราจะตั้งค่าคุกกี้หลายรายการเพื่อบันทึกข้อมูลการเข้าสู่ระบบและตัวเลือกการแสดงหน้าจอของคุณ
                คุกกี้การเข้าสู่ระบบมีอายุการใช้งานสองวันและตัวเลือกหน้าจอคุกกี้มีอายุการใช้งานหนึ่งปี หากคุณเลือก “จดจำฉัน”
                การเข้าสู่ระบบของคุณจะคงอยู่เป็นเวลาสองสัปดาห์ หากคุณออกจากระบบบัญชีของคุณคุกกี้การเข้าสู่ระบบจะถูกลบออก
                หากคุณแก้ไขหรือเผยแพร่บทความคุกกี้เพิ่มเติมจะถูกบันทึกไว้ในเบราว์เซอร์ของคุณ
                คุกกี้นี้ไม่มีข้อมูลส่วนบุคคลและเพียงระบุรหัสโพสต์ของบทความที่คุณเพิ่งแก้ไข จะหมดอายุหลังจาก 1 วัน
            </p>
            <h5>
                <b>การรักษาความปลอดภัยของข้อมูล</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; ข้อมูลทั้งหมดที่คุณให้กับเราจะถูกเก็บไว้บนเซิร์ฟเวอร์ที่มีความปลอดภัย เราได้ส่ง (หรือที่คุณได้เลือก)
                รหัสผ่านสำหรับเข้าถึงบางส่วนของเว็บไซต์และแอพพลิเคชั่นของเรา คุณจะเป็นผู้รับผิดชอบในการรักษาความลับของรหัสผ่านนี้
                เราขอให้คุณไม่แบ่งปันรหัสผ่านนี้กับผู้อื่น
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp; การถ่ายโอน
                จัดเก็บและการดำเนินการกับข้อมูลที่เราทำการรวบรวมผ่านเว็บไซต์และแอพพลิเคชั่นนี้เป็นไปอย่างปลอดภัยตามกระบวนและเครื่องมือรักษาความปลอดภัยที่มีอยู่ในขณะนี้
                แต่ทว่า การส่งข้อมูลผ่านทางอินเทอร์เน็ตนั้นอาจไม่ปลอดภัยอย่างสมบูรณ์ แม้ว่าเราจะได้พยายามอย่างเต็มที่ในการปกป้องข้อมูลส่วนตัวของคุณ
                เราก็ไม่อาจรับประกันความปลอดภัยของข้อมูลที่คุณส่งมายังเว็บไซต์และแอพพลิเคชั่นของเรา ได้ การส่งข้อมูลใดก็ตามเป็นความเสี่ยงของคุณเอง
                เมื่อเราได้รับข้อมูลจากคุณแล้ว
                เราจะใช้ขั้นตอนและคุณลักษณะด้านความปลอดภัยที่เข้มงวดเพื่อพยายามป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
            </p>
            <h5>
                <b>การนำข้อมูลไปใช้งาน</b>
            </h5>
            <p></p>
            <h6>เรานำข้อมูลที่เราเก็บไว้เกี่ยวกับคุณไปใช้เพื่อจุดประสงค์ต่อไปนี้</h6>
            – เพื่อสร้างความมั่นใจว่าเนื้อหาจากเราได้รับการนำเสนออย่างมีประสิทธิภาพมากที่สุดสำหรับคุณและคอมพิวเตอร์ของคุณ
            <br />
            - เพื่อในกรณีที่ต้องติดต่อคุณเกี่ยวกับการดำเนินการและด้านเทคนิคที่เกี่ยวข้องกับการใช้งานเว็บไซต์และแอพพลิเคชั่นของคุณ
            <br />
            – เพื่อจัดหาข้อมูล ผลิตภัณฑ์หรือบริการที่คุณร้องขอจากเราหรือที่คุณอาจสนใจให้คุณ <br />
            ตามที่คุณได้แสดงความยินยอมที่จะรับการติดต่อเพื่อจุดประสงค์ดังกล่าว –
            เพื่อกระทำการตามภาระหน้าที่ของเราที่ระบุไว้ในสัญญาซึ่งทำขึ้นระหว่างคุณกับเรา <br />
            – เพื่อให้คุณสามารถมีส่วนร่วมกับฟังก์ชั่นการโต้ตอบใดๆ บนเว็บไซต์และแอพพลิเคชั่นได้เมื่อคุณต้องการ <br />
            – เพื่อแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงบริการต่างๆ ของเรา
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; เราจะไม่เปิดเผยข้อมูลที่สามารถระบุตัวบุคคลให้แก่ผู้โฆษณาของเรา
            แต่เราอาจจะให้พวกเขามีข้อมูลในภาพรวมเกี่ยวกับผู้ใช้งานเว็บไซต์และแอพพลิเคชั่น ซึ่งเป็นข้อมูลทางสถิติเกี่ยวกับ
            การเรียกดูและรูปแบบการเรียกดูเว็บไซต์และแอพพลิเคชั่นของผู้ใช้ และไม่ได้ระบุแยกเป็นรายบุคคล
            <p></p>
            <h5>
                <b>การเปิดเผยข้อมูลของคุณ</b>
            </h5>
            <p>เราอาจจะเปิดเผยข้อมูลส่วนตัวของคุณโดยตรงหรือโดยอ้อมให้กับกลุ่มบุคคลที่สาม ดังนี้</p>
            <p>
                • ในกรณีที่เราใช้บุคคลที่สามในการพัฒนาเว็บไซต์และแอพพลิเคชั่นของเราและ/หรือดูแลรักษาและ/หรือให้การโฆษณา/ ดำเนินการทางการตลาดและ /
                หรือโฮสติ้งหรือบริการทางเทคนิคอื่น ๆ <br />
                <br />• หากเรามีหน้าที่จะต้องเปิดเผยหรือแบ่งปันข้อมูลส่วนตัวของคุณเพื่อให้เป็นไปตามที่กฎหมายกำหนดไว้ หรือเพื่อบังคับใช้
                หรือข้อตกลงอื่นไปใช้ หรือเพื่อปกป้องสิทธิ์, ทรัพย์สิน หรือความปลอดภัยของบริษัทฯ และลูกค้าของเรา หรืออื่นๆ
            </p>
            ทั้งนี้ให้รวมถึงการแลกเปลี่ยนข้อมูลกับบริษัทและองค์กรอื่นเพื่อจุดประสงค์ในการป้องกันการฉ้อโกงและการลดความเสี่ยงด้านเครดิตด้วย
            <p></p>
            <h5>
                <b>สิทธิของคุณ</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; คุณมีสิทธิที่จะขอให้เราไม่ดำเนินการกับข้อมูลส่วนตัวของคุณเพื่อจุดประสงค์ทางการตลาด
                โดยปกติเราจะแจ้งให้คุณทราบหากเราต้องการนำข้อมูลของคุณไปใช้เพื่อจุดประสงค์ดังกล่าว (แจ้งให้ทราบก่อนการรวบรวมข้อมูล)
                ถ้าเราตั้งใจที่จะใช้ข้อมูลของคุณหรือตั้งใจที่จะเปิดเผยข้อมูลของคุณไปยังบุคคลที่สามเพื่อวัตถุประสงค์ดังกล่าว
                ตามแต่กรณีที่อยู่นอกขอบเขตของการใช้งานของเว็บไซต์และแอพพลิเคชั่นของเรา
                คุณสามารถใช้สิทธิในการป้องกันการดำเนินการดังกล่าวโดยการเลือกจากช่องข้อความในแบบฟอร์มของเรา คุณสามารถใช้สิทธิได้ตลอดเวลาโดยติดต่อเรา
                &nbsp; <b>Gmail: genebank.rd@gmail.com</b>
            </p>
            <h5>
                <b>เว็บไซต์ของบุคคลที่สาม</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; บนเว็บไซต์และแอพพลิเคชั่นของเราอาจจะมีลิงค์เชื่อมโยงไปยังเว็บไซต์อื่นๆ
                หรือคุณอาจใช้ลิงค์ในเว็บไซต์อื่นเพื่อเข้ามาในเว็บไซต์และแอพพลิเคชั่นของเรา
                โปรดทราบว่าเราไม่สามารถที่จะรับผิดชอบต่อนโยบายและวิธีการปฏิบัติเกี่ยวกับการคุ้มครองความเป็นส่วนตัวของเว็บไซต์อื่นๆ ได้
                เนื้อหาของนโยบาย และวิธีการปฏิบัติดังกล่าวจะขึ้นอยู่กับเงื่อนไข และข้อตกลงในการใช้บริการ และแนวทางการปฏิบัติ
                รวมไปถึงข้อมูลที่เกี่ยวข้องกับการคุ้มครองความเป็นส่วนตัวที่ให้ไว้เพิ่มเติมซึ่งเกี่ยวกับการใช้บริการของเว็บไซต์เหล่านั้น
                กรุณาตรวจสอบนโยบายของแต่ละเว็บไซต์ที่คุณเข้าเยี่ยมชม เพื่อจะได้เข้าใจถึงสิทธิและข้อผูกพันของคุณให้มากยิ่งขึ้น
            </p>
            <h5>
                <b>การเข้าถึงข้อมูล</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; ตามนโยบายสิทธิส่วนบุคคลฉบับนี้ คุณมีสิทธิ์ที่จะทราบว่าเราเก็บข้อมูลเกี่ยวกับคุณ (หากเราทำการจัดเก็บ)
                และมีสิทธิ์ที่จะเข้าถึงและขอแก้ไขหากข้อมูลดังกล่าวนั้นไม่ถูกต้อง นอกจากนี้คุณยังมีสิทธิ์ที่จะแจ้งลบหรือกีดกันการดำเนินการใดๆ
                กับข้อมูลเหล่านั้น หากการกระทำนั้นถือเป็นการละเมิดสิทธิส่วนบุคคล เราจะเก็บรักษาข้อมูลไว้นานเท่าไร
                เราจะเก็บรักษาข้อมูลของท่านไว้นานเท่าที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ของการรวบรวมข้อมูลดังกล่าว หรือตามแต่กฎหมายจะกำหนด
            </p>
            <h5>
                <b>การเปลี่ยนแปลงแก้ไขนโยบายฉบับนี้</b>
            </h5>
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp; ในกรณีที่มีการเปลี่ยนแปลงใดๆ เกี่ยวกับนโยบายฉบับนี้ในอนาคต
                เราจะตีพิมพ์ข้อมูลการเปลี่ยนแปลงลงบนหน้าบนเว็บไซต์และแอพพลิเคชั่นนี้ตามความเหมาะสมและจะแจ้งให้คุณทราบผ่านบนเว็บไซต์และแอพพลิเคชั่น
                ติดต่อเรา
            </p>
            <b>
                หากท่านมีข้อสงสัย ข้อเสนอแนะหรือต้องการติดต่อเราเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ สามารถติดต่อเราที่ &nbsp;
                <b>Gmail: genebank.rd@gmail.com</b>
                <div className="text-center mt-5">
                    ที่อยู่: สถาบันวิทยาศาสตร์ข้าวแห่งชาติ เลขที่ 213 หมู่ 5 ถนนมาลัยแมน ตำบลรั้วใหญ่ อำเภอเมือง จังหวัดสุพรรณบุรี 72000
                </div>
            </b>
            <br />
            <br />
            <br />
            <br />
        </div>
    );
}
